<!--
Componente per la gestione delle attività di un paziente

Parametri che si ricevono dalla vista dove viene richiamato il componente

    PARAMETRO                     TIPOLOGIA         REQUIRED      DEFAULT             DESCRIZIONE
    modal_id                      String            FALSE         gap_modal           ID con cui viene richiamato il modale
    fix_model_id                  Number            FALSE         no default          ID del record per la polimorfica
    fix_model_type                String            FALSE         no default          TYPE del record per la polimorfica
    already_connect               Boolean           FALSE         false               Indica se c'è già una GAP collegata (utile in caso di tabelle per evitare chiamate di controllo)
    ref_activity                  Number            FALSE         0                   L'activity di riferimento
    description                   String            FALSE         ''                  La descrizione che si vuole preimpostare
    guest_business_unit_id        Array             FALSE         no default          ---
    business_unit_id              Number            TRUE          no default          ---
    only_new_plan                 Boolean           FALSE         false               Abilita l'inserimento del piano ma non il collegamento a uno esistente
    grid_create                   Boolean           FALSE         false               Permette di creare una grid anziche un guest_activity_plan
    is_single                     Boolean           FALSE         true                Permette di collegare una singola attività di default
    is_planned                    Boolean           FALSE         true                Permette di inserire di default la pianificazione
    new_plan_action               Boolean           FALSE         true                Preselezione del radio button per la creazione di una guest_activity_plan
    users                         Array, NULL       FALSE         null                Serve per inviare gli ID operatori nella parte domiciliare
    domiciliare                   Boolean           FALSE         false               Serve per definire una GAP domiciliare
    multi_guest                   Boolean           FALSE         false
-->

<template>
  <div>
    <div
      aria-hidden="true"
      :aria-labelledby="this.modal_id"
      data-backdrop="static"
      data-keyboard="false"
      class="modal fade hide"
      :id="this.modal_id"
      role="dialog"
      style="max-width: 680px; width: 88%"
    >
      <div class="modal-header">
        <h3 class="title">
          {{ i18nJS.activities_planning }}
          <button @click="closeModal()" aria-hidden="true" class="close" data-dismiss="modal" type="button">
            <i class="fa-light fa-xmark"></i>
          </button>
        </h3>
        <div class="text-danger" v-if="this.error_msg">
          <div v-html="this.error_msg"></div>
        </div>
      </div>
      <div class="modal-body form-horizontal" style="min-height: 400px">
        <div class="activityContainer">
          <div v-if="!domiciliare" class="actionsContainer">
            <!-- Parziale per definire l'azione che sto effettuando nel form sottostante -->
            <chose-plan-action
              :edit_mode="edit_plan"
              :grid_mode="connected_with_grid"
              :plan_action="plan_action"
              @newMode="onClickNew"
              @connectMode="onClickConnect"
            />
          </div>
          <div v-if="!connected_with_grid">
            <hr />
            <template v-if="!gbu_id">
              <div v-if="this.residue !== null" class="control-group">
                <label class="control-label">Residuo</label>
                <div class="controls">
                  <label class="control-label" :value="this.residue">{{ this.residue }}</label>
                </div>
              </div>
              <div v-if="this.notes !== null" class="control-group">
                <label class="control-label">Note impegnativa</label>
                <div class="controls">
                  <label style="width: 60%" class="control-label" :value="this.notes">{{ this.notes }}</label>
                </div>
              </div>
              <div class="control-group">
                <label class="control-label">{{ i18nJS.guest_label }}</label>
                <div class="controls">
                  <GuestBusinessUnitsSelector
                    :multiple="this.multi_guest"
                    v-model="guest_business_unit_id"
                    :only_presents="only_presents"
                  />
                </div>
              </div>
            </template>
            <template v-else>
              <div class="control-group">
                <label class="control-label">{{ i18nJS.guest_label }}</label>
                <div class="controls">
                  {{ guest_full_name }}
                </div>
              </div>
            </template>
            <!-- Se non passo una activity o l'area non è definita allora la faccio selezionare altrimenti non posso completare la creazione -->
            <template v-if="!domiciliare && (ref_activity === 0 || ref_activity === 'null' || area === null)">
              <div class="wrapper">
                <div class="control-group">
                  <label class="control-label">{{ i18nJS.area }}</label>
                  <div class="choser controls">
                    <v-select2
                      :key="`area-${guest_business_unit_id || 'none'}`"
                      :value="areaId || ref_activity"
                      v-model="areaId"
                      :options-list="areaOptions"
                      :data-ajax--url="`${base_url}/activities_configs.json?type=area${guest_business_unit_id ? `&guest_business_unit_id=${guest_business_unit_id}` : ''}`"
                      data-allow-clear="true"
                    />
                  </div>
                </div>
                <template v-if="area">
                  <div v-if="area" class="viewer"></div>
                </template>
              </div>
            </template>
            <template v-if="!plan_action && areaId !== null">
              <div class="infoContainer">
                <div class="control-group">
                  <label class="control-label">
                    {{ i18nJS.grid_label }}
                  </label>
                  <div class="controls">
                    <div class="choser">
                      <v-select2
                        :key="activityId || areaId || ref_activity"
                        :value="activityId"
                        v-model="activityId"
                        :options-list="activityOptions"
                        data-allow-clear="true"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template v-if="plan_action && areaId !== null">
              <div class="form-group form-horizontal">
                <div>
                  <template v-if="is_single">
                    <div class="control-group">
                      <label class="control-label">{{ i18nJS.activity_label }}</label>
                      <div class="controls">
                        <v-select2
                          :key="`${areaId}-${activityOptions.length}`"
                          :value="activityId"
                          v-model="activityId"
                          :options-list="activityOptions"
                          data-allow-clear="true"
                        />
                      </div>
                    </div>
                    <div v-if="subActivities.length !== 0">
                      <div class="control-group">
                        <span v-if="subActivities.length > 10">
                          <label class="control-label"></label>
                          <div class="controls">
                            <input type="text" placeholder="cerca sotto-attività" id="js-subactivities-find" />
                          </div>
                        </span>
                        <label class="control-label">Multi attività</label>
                        <div class="control-group sub-activities-configs-list">
                          <ul id="ul-subactivities">
                            <div v-for="subActivity in subActivities" :key="subActivity.id">
                              <li>
                                <input
                                  :id="subActivity.id"
                                  :value="subActivity.id"
                                  type="checkbox"
                                  :checked="subActivity.status"
                                  @change="
                                    (e) => {
                                      changeSubActivities(subActivity.id, e);
                                    }
                                  "
                                />
                                {{ subActivity.text }}
                              </li>
                            </div>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div class="control-group">
                      <label class="control-label" for="description">{{ i18nJS.description }}</label>
                      <div class="controls">
                        <input type="text" id="description" class="form-control" v-model="activityDescription" />
                        <div class="inline" v-if="descriptionIsChange">
                          <a @click="updateActivityDescription">Sovrascrivi con originale</a>
                        </div>
                      </div>
                    </div>
                    <template v-if="grid_create">
                      <div class="control-group">
                        <label class="control-label">{{ i18nJS.forms.guest_activity_plans.data['datein'] }}</label>
                        <div class="controls">
                          <datepicker :value="data.datein" @input="(val) => (data.datein = val)" id="datein" />
                        </div>
                      </div>
                      <div class="control-group">
                        <label class="control-label">{{ i18nJS.forms.guest_activity_plans.data['dateout'] }}</label>
                        <div class="controls">
                          <datepicker :value="data.dateout" @input="(val) => (data.dateout = val)" id="dateout" />
                        </div>
                      </div>
                    </template>

                    <template v-if="areaMotivations.length !== 0">
                      <div class="control-group">
                        <label class="control-label">{{ i18nJS.forms.guest_activity_plans.data['giudizio_pred'] }}</label>
                        <div class="controls">
                          <v-select2
                            :key="areaId || ref_activity"
                            v-model="giudizioPredefinito"
                            :options-list="areaMotivations"
                            data-allow-clear="true"
                          />
                        </div>
                      </div>
                    </template>
                    <template v-if="areaAutonomies.length !== 0">
                      <div class="control-group">
                        <label class="control-label">{{ i18nJS.forms.guest_activity_plans.data['autonomia_pred'] }}</label>
                        <div class="controls">
                          <v-select2
                            :key="areaId || ref_activity"
                            v-model="autonomiaPredefinita"
                            :options-list="areaAutonomies"
                            data-allow-clear="true"
                          />
                        </div>
                      </div>
                    </template>
                    <template v-if="areaPartecipations.length !== 0">
                      <div class="control-group">
                        <label class="control-label">{{ i18nJS.forms.guest_activity_plans.data['partecipazione_pred'] }}</label>
                        <div class="controls">
                          <v-select2
                            :key="areaId || ref_activity"
                            v-model="partecipazionePredefinita"
                            :options-list="areaPartecipations"
                            data-allow-clear="true"
                          />
                        </div>
                      </div>
                    </template>

                    <div class="control-group">
                      <label class="control-label" for="timestd2">{{ i18nJS.timestd }}</label>
                      <div :class="['controls', { obbligatorio: domiciliare }]">
                        <input type="text" id="timestd2" class="form-control input-mini" v-model="durationStd" />
                        <div class="inline" v-if="durationIsChange">
                          <a @click="updateDurationStd">Riprendi durata attività</a>
                        </div>
                      </div>
                    </div>

                    <template v-if="grid_create">
                      <div class="control-group">
                        <label for="nrope" class="control-label">{{ i18nJS.nrope }}</label>
                        <div class="controls">
                          <input type="number" id="nrope" class="form-control" v-model="nrOpe" />
                        </div>
                      </div>
                      <div class="control-group">
                        <label for="nrosp" class="control-label">{{ i18nJS.nrosp }}</label>
                        <div class="controls">
                          <input type="number" id="nrosp" class="form-control" v-model="nrOsp" />
                        </div>
                      </div>
                    </template>
                  </template>

                  <template v-if="!is_single">
                    <div class="infoContainer">
                      <div class="title">
                        <p>
                          Questo gruppo è fatto da una sola attività o da attività diverse?
                          <br />
                          <small>(se no salta al punto successivo)</small>
                        </p>
                      </div>
                      <div class="wrapper">
                        <template v-if="data.single_activity">
                          <div class="viewer">
                            <div class="control-group">
                              <div class="controls">
                                <v-select2
                                  :key="areaId || ref_activity"
                                  :value="activityId"
                                  v-model="activityId"
                                  :options-list="activityOptions"
                                  data-allow-clear="true"
                                />
                              </div>
                            </div>
                            <div class="control-group">
                              <label class="control-label" for="timestd1">{{ i18nJS.timestd }}</label>
                              <div class="controls">
                                <input type="text" id="timestd1" class="form-control" v-model="durationStd" />
                              </div>
                            </div>
                            <div class="control-group">
                              <label class="control-label" for="description">
                                {{ i18nJS.forms.guest_activity_plans.data['giudizio_pred'] }}
                              </label>
                              <div class="controls">
                                <v-select2 v-model="data.giudizio_predef" :options-list="areaMotivations" data-allow-clear="true" />
                              </div>
                            </div>
                            <div class="control-group">
                              <label class="control-label" for="description">
                                {{ i18nJS.forms.guest_activity_plans.data['autonomia_pred'] }}
                              </label>
                              <div class="controls">
                                <v-select2
                                  :key="areaId || ref_activity"
                                  v-model="data.autonomia_predef"
                                  :options-list="areaAutonomies"
                                  data-allow-clear="true"
                                />
                              </div>
                            </div>
                            <div class="control-group">
                              <label class="control-label" for="description">
                                {{ i18nJS.forms.guest_activity_plans.data['partecipazione_pred'] }}
                              </label>
                              <div class="controls">
                                <v-select2
                                  :key="areaId || ref_activity"
                                  v-model="data.partecipazione_predef"
                                  :options-list="areaPartecipations"
                                  data-allow-clear="true"
                                />
                              </div>
                            </div>
                          </div>
                        </template>
                      </div>
                    </div>
                  </template>
                  <div class="section">
                    <div class="infoContainer">
                      <div class="wrapper">
                        <template v-if="is_planned">
                          <div class="extended">
                            <div class="control-group">
                              <label class="control-label">{{ i18nJS.start_label }}</label>
                              <div :class="['controls', { obbligatorio: domiciliare }]">
                                <datepicker :value="fromDate" @input="(val) => (fromDate = val)" />
                                <timepicker :value="fromTime" @input="(val) => (fromTime = val)" />
                              </div>
                            </div>

                            <template v-if="grid_create === false">
                              <div class="control-group">
                                <label class="control-label">{{ i18nJS.fino_al }}</label>
                                <div :class="['controls', { obbligatorio: default_date_out }]">
                                  <datepicker v-if="!default_date_out" :value="repeatsEndOn" @input="(val) => (repeatsEndOn = val)" />
                                  <datepicker v-else :value="repeatsEndOn" @input="(val) => (repeatsEndOn = val)" />
                                </div>
                              </div>
                            </template>
                            <div class="control-group" v-if="repeatEvery !== null">
                              <label class="control-label">{{ i18nJS.repeated }}</label>
                              <div class="controls">
                                <input type="number" class="form-control input-mini" v-model="repeatEveryInterval" />
                                <v-select2
                                  :value="repeatEvery"
                                  v-model="repeatEvery"
                                  :options-list="repeatsValue"
                                  data-allow-clear="true"
                                />
                                <div class="m_top" v-if="repeatEvery === 1">
                                  <label class="inline">
                                    <input type="checkbox" value="1" :checked="repeatDaily" v-model="repeatDaily" />
                                    {{ i18nJS.repeats_each_hour }}
                                  </label>

                                  <template v-for="(n, hour) in 24">
                                    <template v-if="repeatDaily">
                                      <label :key="n + '1'" class="input-checkbox-auto" :for="hour + '_00_hour'">
                                        <input
                                          :id="hour + '_00_hour'"
                                          :value="hour + ':00'"
                                          type="checkbox"
                                          :checked="selectedHoursOfDay.includes(('0' + hour).slice(-2) + ':00')"
                                          @change="onChangeHour(('0' + hour).slice(-2) + ':00', $event)"
                                        />
                                        {{ ('0' + hour).slice(-2) + ':00' }}
                                      </label>
                                      <label :key="n + '12'" class="input-checkbox-auto" :for="hour + '_30_hour'">
                                        <input
                                          :id="hour + '_30_hour'"
                                          :value="hour + ':30'"
                                          type="checkbox"
                                          :checked="selectedHoursOfDay.includes(('0' + hour).slice(-2) + ':30')"
                                          @change="onChangeHour(('0' + hour).slice(-2) + ':30', $event)"
                                        />
                                        {{ ('0' + hour).slice(-2) + ':30' }}
                                      </label>
                                    </template>
                                  </template>
                                </div>

                                <div class="m_top" v-if="repeatEvery === 2">
                                  <label for="all_day_week" class="inline">
                                    <input type="checkbox" id="all_day_week" v-model="allDayWeek" />
                                    {{ i18nJS.days_of_month.all_days }}
                                  </label>
                                  <label class="m_top input-checkbox-auto" v-for="day in daysOfWeek" :for="day + '_week'" :key="day">
                                    <input
                                      :id="day + '_week'"
                                      type="checkbox"
                                      :checked="selectedDaysOfWeek.includes(day)"
                                      @change="onChangeDay(day, $event)"
                                    />
                                    {{ i18nJS.weeks['day_' + (day + 1)] }}
                                  </label>
                                </div>

                                <div class="m_top" v-if="repeatEvery === 3">
                                  <div v-if="repeatMonthly !== null">
                                    <v-select2
                                      :value="repeatMonthly"
                                      v-model="repeatMonthly"
                                      :options-list="repeatMonthlyOptions"
                                      data-allow-clear="true"
                                    />
                                    <div class="m_top">
                                      <div v-if="repeatMonthly === 1">
                                        <span v-for="(day, index) in 31" :key="index + '1'">
                                          <label class="input-checkbox-auto" :for="day + '_month'">
                                            <input
                                              :id="day + '_month'"
                                              type="checkbox"
                                              :checked="selectedDaysOfMonth.includes(day)"
                                              @change="onChangeMonth(day, $event)"
                                            />
                                            {{ day }}
                                          </label>
                                        </span>
                                      </div>
                                      <div v-if="repeatMonthly === 2">
                                        <div>
                                          {{ i18nJS.week }}
                                          <br />
                                          <label v-for="on in 4" class="input-checkbox-auto" :for="on + '_on'" :key="on">
                                            <input
                                              class="week_on_month"
                                              :id="on + '_on'"
                                              type="checkbox"
                                              :checked="selectedPeriodOfMonth.includes(on)"
                                              @change="onChangeMonthPeriod(on, $event)"
                                            />
                                            {{ i18nJS.on['on_' + on] }}
                                          </label>
                                          <label class="input-checkbox-auto">
                                            <input
                                              :id="'-1_on'"
                                              :value="'-1_on'"
                                              type="checkbox"
                                              :checked="selectedPeriodOfMonth.includes(-1)"
                                              @change="onChangeMonthPeriod(-1, $event)"
                                            />
                                            {{ i18nJS.on['on_' + 5] }}
                                          </label>
                                        </div>
                                        <hr />
                                        <div>
                                          {{ i18nJS.day }}
                                          <br />
                                          <label v-for="day in daysOfWeek" class="input-checkbox-auto" :for="day + '_year'" :key="day">
                                            <input
                                              :id="day + '_year'"
                                              type="checkbox"
                                              :checked="selectedDaysOfWeek.includes(day + '_year')"
                                              @change="onChangeDay(day + '_year', $event)"
                                            />
                                            {{ i18nJS.weeks['day_' + (day + 1)] }}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="m_top" v-if="repeatEvery === 4">
                                  <label v-for="month in 12" class="input-checkbox-auto" :for="month" :key="month">
                                    <input
                                      :id="month"
                                      type="checkbox"
                                      :checked="selectedMonthOfYear.includes(month.toString())"
                                      @change="onChangeDay(month, $event)"
                                    />
                                    {{ i18nJS.months['month_' + month] }}
                                  </label>
                                </div>
                              </div>
                            </div>

                            <template v-if="!grid_create">
                              <div class="control-group">
                                <label class="control-label" for="notes">{{ i18nJS.notes }}</label>
                                <div class="controls">
                                  <textarea id="notes" class="form-control span12" v-model="notes"></textarea>
                                </div>
                              </div>
                            </template>
                          </div>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="area && activity && domiciliare">
                <div class="form-group">
                  <div>
                    <div class="control-group">
                      <label class="control-label" for="duration_std">{{ i18nJS.timestd }}</label>
                      <div class="controls">
                        <input type="text" id="duration_std" class="form-control" v-model="durationStd" />
                      </div>
                    </div>
                    <div class="control-group">
                      <label class="control-label" for="nrope">{{ i18nJS.nrope }}</label>
                      <div class="controls">
                        <input type="text" id="nrope" class="form-control" v-model="nrOpe" />
                      </div>
                    </div>
                    <div class="control-group">
                      <label class="control-label" for="nrosp">{{ i18nJS.nrosp }}</label>
                      <div class="controls">
                        <input type="text" id="nrosp" class="form-control" v-model="nrOsp" />
                      </div>
                    </div>
                    <div class="control-group">
                      <label class="control-label">Da</label>
                      <div class="controls">
                        <datepicker :value="fromDate" @input="(val) => (this.fromDate = val)" id="from_date" />
                      </div>
                    </div>
                    <div class="control-group">
                      <label class="control-label" for="notes">{{ i18nJS.notes }}</label>
                      <div class="controls">
                        <textarea id="notes" class="form-control span12" v-model="notes"></textarea>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
      <div class="modal-footer" v-if="!connected_with_grid">
        <template v-if="!plan_action && activity">
          <button @click="connectExistingPlanToUser()" class="btn btn-primary" :disabled="connectBtnDisabled || requiredForSave">
            {{ i18nJS['save'] }}
          </button>
        </template>
        <template v-if="plan_action && grid.length === 0 && grid_create">
          <button @click="createGrid()" class="btn btn-primary" :disabled="requiredForSave">{{ i18nJS['save'] }}</button>
        </template>
        <template v-if="plan_action && !edit_plan && grid.length === 0 && !grid_create">
          <button @click="createGap()" class="btn btn-primary" :disabled="saveBtnDisabled || requiredForSave">
            {{ i18nJS['save'] }}
          </button>
        </template>
        <template v-if="plan_action && edit_plan && grid.length === 0 && !grid_create">
          <button @click="updateGap()" class="btn btn-primary" :disabled="editBtnDisabled || requiredForSave">
            {{ i18nJS.command['edit'] }}
          </button>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
// GAP = guest_activity_plans
import apiConnector from '@/epersonam/apiConnector';
import vSelect2 from '../vSelect2';
import datepicker from '../datepicker';
import timepicker from '../timepicker';
import GuestBusinessUnitsSelector from '../form/GuestBusinessUnitsSelector';
import ChosePlanAction from './chosePlanAction';

export default {
  name: 'guestActivityPlanForm',
  props: {
    modal_id: { type: String, default: 'gap_modal' },

    ref_activity: { type: Number, default: 0 },
    gbu_id: { type: [Number, Boolean] },
    guest_full_name: { type: String },
    business_unit_id: { type: Number, required: true },

    only_new_plan: { type: Boolean, default: true },
    grid_create: { type: Boolean, default: false },
    is_single: { type: Boolean, default: true },
    is_planned: { type: Boolean, default: true },

    new_plan_action: { type: Boolean, default: true },
    users: { type: [Array, null], default: null },
    domiciliare: { type: Boolean, default: false },

    fix_model_id: { type: Number },
    fix_model_type: { type: String },

    whitelist_enabled: { type: Boolean },

    connected_plans: { type: [Array, null] },
    connected_with_grid: { type: Boolean, default: false },
    already_connect: { type: Boolean, default: false },
    multi_guest: { type: Boolean, default: false },

    override_description: { type: String, default: '' },
    override_notes: { type: String, default: '' },
    override_start: { type: String, default: '' },
    override_end: { type: String, default: '' },
    default_date_out: { type: Boolean, default: false },

    only_presents: { type: Boolean, default: false },

    callback_function_on_success: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    ChosePlanAction,
    vSelect2,
    datepicker,
    timepicker,
    GuestBusinessUnitsSelector,
  },
  data() {
    return {
      locked_activity_configs_call: true,
      residue: null,
      notes: null,
      guest_business_unit_id: null,
      daysOfWeek: [...Array(7).keys()],
      repeatsValue: [
        [window.i18nJS.interval['never'], 0],
        [window.i18nJS.interval['daily'], 1],
        [window.i18nJS.interval['weekly'], 2],
        [window.i18nJS.interval['monthly'], 3],
        [window.i18nJS.interval['yearly'], 4],
      ],

      timeOffsetInMilliseconds: Math.abs(new Date().getTimezoneOffset()) * 1000 * 60,

      connectedGuestActivityPlan: null,

      repeatsEachHour: '1',

      error_msg: null,

      inLoading: false,

      allDayWeek: false,

      plan_action: this.new_plan_action || this.domiciliare,
      edit_plan: this.already_connect,
      editFirstLoad: false,

      area: null,
      areaId: this.ref_activity,
      areaOptions: [],

      areaMotivations: [],
      areaAutonomies: [],
      areaPartecipations: [],

      activity: [],
      activityId: null,
      activityDescription: '',
      activityOptionsRaw: [],
      subActivities: [],

      selectedHoursOfDay: [],
      selectedDaysOfWeek: [],
      selectedDaysOfMonth: [],
      selectedMonthOfYear: [],
      selectedPeriodOfMonth: [],

      fromDate: '',
      fromTime: '',
      repeatsEndOn: '',
      nrOsp: 1,
      nrOpe: 1,
      repeatEvery: null,
      repeatEveryInterval: 1,

      giudizioPredefinito: null,
      autonomiaPredefinita: null,
      partecipazionePredefinita: null,

      durationStd: null,
      repeatsEndOnVal: false,

      repeatDaily: false,
      repeatMonthly: false,
      repeatMonthlyOptions: [
        [window.i18nJS.interval['giorno_del_mese'], 1],
        [window.i18nJS.interval['giorno_della_settimana'], 2],
      ],

      grid: [],
      data: {
        repeats_each_hour: '1',
        datein: '',
        dateout: '',
        single_activity: this.is_single,
        activities_config_id: this.activities_config_id,
        from_date: '',
        from_time: '',
        repeats_end_on: '',
        notes: '',

        has_plan: this.is_planned,

        all_day_week: this.allDayWeek,

        on: [],
        hours: [],
        days: [],
        months: [],
        repeats_monthly: '',

        users: this.users,
        domiciliare: this.domiciliare,
      },

      gap: 0,
      gapInfo: [],
      gapOptions: [],

      //  Valori per la retrocompoatibilità pre-polimorfica
      guest_drug_id: null,
    };
  },
  watch: {
    repeatsEndOn: function (val) {
      if (this.default_date_out && (val === null || val === '')) {
        this.repeatsEndOnVal = true;
      } else {
        this.repeatsEndOnVal = false;
      }
    },
    fromDate: function (val) {
      if (this.default_date_out) {
        this.repeatsEndOn = moment(new Date(this.formatDate(val)))
          .add(1, 'M')
          .format('DD/MM/YYYY');
      }
      const formattedDate = moment(new Date(this.formatDate(val)));
      const month = formattedDate.format('M');

      if (!this.selectedMonthOfYear.includes(month)) {
        this.selectedMonthOfYear.push(month);
      }
    },
    repeatMonthly: function () {
      if (typeof this.repeatMonthly === 'string') {
        this.repeatMonthly = parseInt(this.repeatMonthly);
      }
    },
    repeatEvery: function () {
      if (typeof this.repeatEvery === 'string') {
        this.repeatEvery = parseInt(this.repeatEvery);
      }
    },
    guest_business_unit_id: function () {
      if (this.whitelist_enabled) {
        if (this.guest_business_unit_id) {
          this.locked_activity_configs_call = false;

          this.loadActivities();
        } else {
          this.locked_activity_configs_call = true;
        }
      }

      if (this.guest_business_unit_id !== undefined && this.guest_business_unit_id !== null) {
        const size = this.guest_business_unit_id.length;
        if (size <= 1) {
          let params = {
            guest_business_unit_id: this.guest_business_unit_id[0],
          };
          apiConnector()
            .get(this.base_url + '/domestic/residual_calculation_gpdse.json', { params: params })
            .then((res) => {
              if (res.data[0].nrgg_autorizzate !== undefined) {
                const nrgg_autorizzate = res.data[0].nrgg_autorizzate;
                const completed = res.data[0].size;
                this.residue = nrgg_autorizzate - completed;
                this.notes = res.data[0].notes;
              } else {
                this.residue = null;
              }
            })
            .catch((err) => {
              console.log('Could not set initial value', err);
            });
        } else {
          this.residue = null;
        }
      } else {
        this.residue = null;
      }
    },
    plan_action: function () {
      if (!this.area) return;

      this.areaId = null;
      this.areaOptions = null;
      this.activity = null;
      this.activityId = null;
      this.activityOptionsRaw = [];

      this.loadActivities();
    },
    allDayWeek: function () {
      if (this.allDayWeek === true) {
        this.data.allDayWeek = true;
        this.selectedDaysOfWeek = [0, 1, 2, 3, 4, 5, 6];
      } else {
        this.data.allDayWeek = false;
        this.selectedDaysOfWeek = [];
      }
    },
    areaId: function (newVal, oldVal) {
      // Reset motivazioni/autonomie/partecipazioni
      this.areaMotivations = [];
      this.areaAutonomies = [];
      this.areaPartecipations = [];

      // Se areaId è null o non cambiato, esci
      if (newVal === null || newVal === undefined || newVal === oldVal) return;

      // Carica i dettagli dell'area solo se necessario (per edit mode o ref_activity)
      // Non serve per selezione da dropdown AJAX perché l'utente ha già scelto
      if (this.area?.id !== newVal && (this.already_connect || this.ref_activity)) {
        this.loadAreaById(newVal);
      } else {
        // Imposta area come oggetto minimo per far funzionare il resto del codice
        this.area = { id: newVal };
      }

      // Carica le attività per questa area
      this.loadActivities();

      // Carica i decodes per i select di motivazione/autonomia/partecipazione
      apiConnector()
        .get(this.base_url + '/activities_configs/decodes_for_select', { params: { id: newVal } })
        .then(({ data }) => {
          if (data['motivation']) this.areaMotivations = Object.values(data['motivation']).map((e) => [e.desc, e.value]);
          if (data['autonomia']) this.areaAutonomies = Object.values(data['autonomia']).map((e) => [e.desc, e.value]);
          if (data['partecipazione']) this.areaPartecipations = Object.values(data['partecipazione']).map((e) => [e.desc, e.value]);
          if (this.areaMotivations.length === 0) {
            Loader.hide();
          }
        })
        .catch((err) => {
          console.log('Could not set initial value', err);
        });
    },
    activityId: function () {
      if (!this.plan_action) {
        this.loadActivityById(this.activityId);
      }
      if (!this.activityId) {
        this.activity = null;
        this.loadActivities();
      } else {
        this.loadActivityById(this.activityId);
        this.activityDescription = this.activityId ? this.activity?.description : '';
        this.durationStd = this.durationStd || this.timeStds.find((a) => a.id === parseInt(this.activityId))?.timestd || 30;
        this.loadSubActivities(this.activityId);
        window.UlFilter.init('#js-subactivities-find', '#ul-subactivities');
      }
    },
    gap: function () {
      apiConnector()
        .get(this.base_url + '/guest_activity_plans/' + this.gap + '.json')
        .then(({ data }) => {
          this.gapInfo = data;
        })
        .catch((err) => {
          console.log('Errore: ', err);
        });
    },
    connectedGuestActivityPlan: function () {
      if (this.connectedGuestActivityPlan === null) {
        return;
      }
      this.repeatEvery = parseInt(this.connectedGuestActivityPlan.rule_type);
    },
  },
  computed: {
    repeatDaysSelect() {
      if (this.repeatEvery === 2) {
        return this.selectedDaysOfWeek;
      }
      if (this.repeatEvery === 3 && this.repeatMonthly === 1) {
        return this.selectedDaysOfMonth;
      }
      if (this.repeatEvery === 3 && this.repeatMonthly === 2) {
        return this.selectedDaysOfWeek;
      }
      if (this.repeatEvery === 4) {
        return null;
      }
      return undefined;
    },
    base_url() {
      const host = window.config?.ePersonamService?.ePersonamHost || '';
      const locale = window.locale || 'it';
      // Ensure absolute path starting with / or full URL
      const prefix = host.startsWith('http') ? host : '';
      return `${prefix}/${locale}`.replace(/\/$/, ''); // Remove trailing slash
    },
    repeatMonthsSelect() {
      if (this.repeatEvery === 2) {
        return null;
      }
      if (this.repeatEvery === 3) {
        return null;
      }
      if (this.repeatEvery === 4) {
        return this.selectedMonthOfYear;
      }
      return undefined;
    },
    repeatEveryDescription() {
      switch (this.repeatEvery) {
        case 1:
          return 'daily';
        case 2:
          return 'weekly';
        case 3:
          return 'monthly';
        case 4:
          return 'yearly';
        default:
          return 'never';
      }
    },
    repeatMonthlyDescription() {
      switch (this.repeatMonthly) {
        case 1:
          return 'each';
        case 2:
          return 'on';
        default:
          return 'each';
      }
    },
    descriptionIsChange() {
      if (!this.activity) {
        return false;
      }

      return this.activityDescription !== this.activity.description;
    },
    durationIsChange() {
      if (!this.activity) {
        return false;
      }
      if (this.activity.timestd === undefined) {
        return false;
      }

      return this.durationStd !== this.activity.timestd;
    },
    i18nJS() {
      return window.i18nJS;
    },
    connectBtnDisabled() {
      return false;
    },
    saveBtnDisabled() {
      return !(
        (!this.domiciliare || this.fromDate) &&
        (!this.domiciliare || this.durationStd) &&
        (this.repeatEvery === 0 || this.repeatsEndOn)
      );
    },
    editBtnDisabled() {
      return false;
    },
    requiredForSave() {
      return (
        ((this.areaId === null || this.areaId === '' || this.areaId === 0) && !this.domiciliare) ||
        this.activityId === null ||
        this.activityId === ''
      );
    },
    activityOptions() {
      if (!Array.isArray(this.activityOptionsRaw) || this.activityOptionsRaw.length === 0) return [];
      return this.activityOptionsRaw.map((e) => [e.description, e.id]);
    },
    timeStds() {
      if (!Array.isArray(this.activityOptionsRaw)) return [];
      return this.activityOptionsRaw.map((e) => {
        return { id: e.id, timestd: e.timestd };
      });
    },
    buildGap() {
      return {
        guest_business_unit_id: this.guest_business_unit_id,
        guest_ids: [this.guest_business_unit_id?.toString()],

        description: this.activityDescription,
        activities_config_id: this.activityId,

        duration_std: this.durationStd,
        giudizio_predef: this.giudizioPredefinito,
        autonomia_predef: this.autonomiaPredefinita,
        partecipazione_predef: this.partecipazionePredefinita,

        notes: this.notes,

        nrope: this.nrOpe,
        nrosp: this.nrOsp,

        repeats_every_n: this.repeatEveryInterval,
        repeats: this.repeatEveryDescription,
        repeats_monthly: this.repeatMonthlyDescription,
        repeats_each_hour: this.repeatsEachHour,

        from_date: this.fromDate,
        from_time: this.fromTime,
        repeats_end_on: this.repeatsEndOn,

        on: this.selectedPeriodOfMonth,
        hours: this.selectedHoursOfDay,
        days: this.repeatDaysSelect,
        months: this.repeatMonthsSelect,

        users: this.data.users,
        domiciliare: this.data.domiciliare,

        model_type: this.fix_model_type,
        model_id: this.fix_model_id,

        //  Valore per la retro-compatibità pre polimorfica
        guest_drug_id: this.guest_drug_id,

        // sottoattivita per pacchetti
        sub_activities: this.buildSubActivitiesForParams(),
      };
    },
  },
  async mounted() {
    this.guest_business_unit_id = this.gbu_id;
    // Assegno la fine della GAP che ho ricevuto nella chiamata a questo componente tramite le PROPS
    if (this.override_end) {
      this.repeatsEndOn = this.dateFormatter(this.override_end);
    }
    if (this.already_connect) {
      let data = await this.loadGuestActivityPlan(this.connected_plans);
      await this.loadConnected(data);
      this.connectedGuestActivityPlan = data;
      this.plan_action = true;
    } else {
      this.repeatEvery = 0;
      if (this.override_notes) {
        this.notes = this.override_notes;
      }
      if (this.override_start) {
        this.fromDate = this.dateFormatter(this.override_start);
      }
      if (this.plan_action === false) {
        this.area = null;
        this.areaOptions = [];
      } else {
        if (this.ref_activity !== 0 && this.ref_activity !== 'null') {
          this.area = { id: this.ref_activity };
          await this.loadActivities();
        } else {
          this.area = null;
        }
      }
      if (this.domiciliare) await this.loadActivities();
    }
  },
  methods: {
    async loadGuestActivityPlan(guestActivityPlanId) {
      return apiConnector()
        .get(this.base_url + '/guest_activity_plans/' + guestActivityPlanId + '.json?guest_activity_plan_form=true')
        .then(({ data }) => {
          return data;
        })
        .catch((err) => {
          console.log('Could not set initial value', err);
        });
    },
    formatDate(date) {
      var parsedDate = date.split('/');
      parsedDate = parsedDate[2] + '-' + parsedDate[1] + '-' + parsedDate[0];
      return parsedDate;
    },
    onChangeHour(value, $event) {
      if (!this.selectedHoursOfDay) {
        this.selectedHoursOfDay = [];
      }

      let index = this.selectedHoursOfDay.findIndex((v) => v === value);
      let checked = $event.target.checked;

      if (checked && index < 0) this.selectedHoursOfDay.push(value);
      if (!checked && index >= 0) this.selectedHoursOfDay.splice(index, 1);
    },
    onChangeMonthPeriod(value, $event) {
      if (!this.selectedPeriodOfMonth) {
        this.selectedPeriodOfMonth = [];
      }

      let index = this.selectedPeriodOfMonth.findIndex((v) => v === value);
      let checked = $event.target.checked;

      if (checked && index < 0) this.selectedPeriodOfMonth.push(value);
      if (!checked && index >= 0) this.selectedPeriodOfMonth.splice(index, 1);
    },
    onChangeDay(value, $event) {
      if (!this.selectedDaysOfWeek) {
        this.selectedDaysOfWeek = [];
      }
      let index = this.selectedDaysOfWeek.findIndex((v) => v === value);
      let checked = $event.target.checked;

      if (checked && index < 0) this.selectedDaysOfWeek.push(value);
      if (!checked && index >= 0) this.selectedDaysOfWeek.splice(index, 1);
    },
    onChangeMonth(value, $event) {
      if (!this.selectedDaysOfMonth) {
        this.selectedDaysOfMonth = [];
      }
      let index = this.selectedDaysOfMonth.findIndex((v) => v === value);
      let checked = $event.target.checked;

      if (checked && index < 0) this.selectedDaysOfMonth.push(value);
      if (!checked && index >= 0) this.selectedDaysOfMonth.splice(index, 1);
    },
    async loadConnected(connected) {
      await this.loadAreaById(null, connected.connect_area);
      await this.loadActivityById(null, connected.connect_activity);

      this.fromDate = this.dateFormatter(connected.from_date);
      let splitted_hours = connected.scheduled_hours.split(';');
      let time = this.timeFormatter(connected.from_time || splitted_hours[0]);
      if (this.edit_plan) {
        this.fromTime = this.timeFormatter(moment(Date.parse('1-1-2000 00' + time) + this.timeOffsetInMilliseconds)._d);
      } else {
        this.fromTime = time;
      }
      this.repeatsEndOn = this.dateFormatter(connected.repeats_end_on);
      this.repeatEveryInterval = connected.interval;
      if (splitted_hours.length > 1) {
        this.repeatEvery = 1;
      }
      this.selectedHoursOfDay =
        this.repeatEvery === 1
          ? splitted_hours.map((el) => this.timeFormatter(moment(Date.parse(el) + this.timeOffsetInMilliseconds)._d))
          : [];
      console.log(this.selectedHoursOfDay);
      if (this.selectedHoursOfDay.length > 1) {
        this.repeatDaily = true;
      }
      if (connected.days_of_week !== '') {
        if (connected.cardinal !== '' && connected.days_of_week === '5') {
          this.repeatMonthly = 2;
          this.selectedPeriodOfMonth = connected.cardinal.split(';').map((el) => parseInt(el));
        } else {
          this.selectedDaysOfWeek = connected.days_of_week.split(';').map((el) => parseInt(el));
        }
      }
      if (connected.days_of_month !== '') {
        this.selectedDaysOfMonth = connected.days_of_month.split(';').map((el) => parseInt(el));

        this.repeatMonthly = this.selectedDaysOfMonth.length > 0 ? 1 : 2;
      }

      this.notes = connected.notes;
      this.activityDescription = connected.description;
    },
    async loadAreaById(id, raw = null) {
      if (!id) return;

      let data = raw;
      if (data === null) {
        data = await this.getActivityById(id);
      }
      if (!data) return;

      // Aggiunge l'area alle options per il select2
      const existingOption = this.areaOptions?.find((opt) => opt[1] === data.id);
      if (!existingOption) {
        this.areaOptions = [[data.description, data.id]];
      }

      this.area = data;
      // NON impostare this.areaId qui per evitare loop con il watcher

      Loader.hide();
    },
    async loadActivityById(id, raw = null) {
      let data = raw;
      if (data === null) {
        data = await this.getActivityById(id);
      }
      if (this.activityOptionsRaw.length === 0 || (!this.domiciliare && this.areaId !== this.activity?.area_id)) {
        this.activityOptionsRaw = [data];
      }

      this.activity = data;
      this.activityId = data.id;
      this.activityDescription = this.activityDescription || data.description;
      Loader.hide();
    },
    async loadActivities() {
      if (this.edit_plan && this.activityOptionsRaw === undefined) {
        return;
      }
      this.activityOptionsRaw = await this.getActivitiesByArea();
      Loader.hide();
    },
    async loadSubActivities(activityId) {
      const response = await this.getSubActivities(activityId);
      this.subActivities = response;
    },
    changeSubActivities(activityId, event) {
      this.subActivities.forEach((subActivity) => {
        if (subActivity.id === activityId) {
          subActivity.status = event.currentTarget.checked;
        }
      });
    },
    buildSubActivitiesForParams() {
      const subActivitiesObj = {};
      this.subActivities.forEach((subActivity) => {
        subActivitiesObj[subActivity.id] = subActivity.status;
      });
      return subActivitiesObj;
    },
    updateActivityDescription() {
      this.activityDescription = this.activity.description;
    },
    updateDurationStd() {
      this.durationStd = this.timeStds.find((a) => a.id === this.activityId)?.timestd || 30;
    },
    onClickNew(value) {
      this.plan_action = value;
    },
    onClickConnect(value) {
      this.plan_action = value;
    },
    getActivitiesByArea() {
      if (this.whitelist_enabled && this.locked_activity_configs_call) {
        return [];
      }

      if (this.whitelist_enabled && !this.guest_business_unit_id) {
        return [];
      }

      let activityUrl = `${this.base_url}/activities_configs.json?search=true&page=null`;
      activityUrl += this.plan_action ? '&type=activity' : '&type=grid';
      if (!this.domiciliare) {
        activityUrl = Utils.addGetParam(activityUrl, 'area_id', this.areaId);
      }

      if (this.guest_business_unit_id) {
        activityUrl = Utils.addGetParam(activityUrl, 'guest_business_unit_id', this.guest_business_unit_id);
      }

      return apiConnector()
        .get(activityUrl)
        .then(({ data }) => {
          return data;
        })
        .catch((err) => {
          console.log('Could not load activities', err);
          return [];
        });
    },
    dateFormatter(date) {
      return new Date(date).toLocaleDateString('it-IT', { month: '2-digit', day: '2-digit', year: 'numeric' });
    },
    timeFormatter(time) {
      return new Date(time).toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' });
    },
    openModal() {
      $('#' + this.modal_id).modal('show');
    },
    closeModal() {
      $('#' + this.modal_id).modal('hide');
    },
    reloadGuestActivities() {
      $('.form-guest_activity_plans-js').submit();
    },
    connectExistingPlanToUser() {
      Loader.show();

      let params = {
        guest_activity_plan: {
          schedule: this.activity.schedule,
          description: this.activity.description,
          activities_config_id: this.activity.single_activity_id,
          guest_business_unit_id: this.guest_business_unit_id,
          guest_ids: [this.guest_business_unit_id.toString()],
          duration_std: this.activity.duration_std,
          nrope: this.activity.nrope,
          nrosp: this.activity.nrosp,
          from_date: new Date(),
          model_type: this.fix_model_type,
          model_id: this.fix_model_id,
          guest_activity_grid_attributes: {
            activities_config_id: this.activityId,
          },
        },
      };
      apiConnector()
        .post(this.base_url + '/guest_activity_plans.json', params)
        .then((res) => {
          this.reloadGuestActivities();
          Loader.hide();
          this.closeModal();
        })
        .catch((err) => {
          Loader.hide();
          console.log('Could not set initial value', err);
        });
    },
    createGrid: function () {
      Loader.show();
      let params = {
        activities_config: {
          is_grid: true,
          is_area: false,
          seed: false,
          area_id: this.areaId,
          activity_id: this.activityId,
          description: this.data.description,
          business_unit_id: this.business_unit_id,
          datein: this.data.datein,
          dateout: this.data.dateout,
          timestd: this.durationStd,

          giudizio_predef: this.giudizioPredefinito,
          autonomia_predef: this.autonomiaPredefinita,
          partecipazione_predef: this.partecipazionePredefinita,

          repeats_every_n: this.repeatEveryInterval,
          repeats: this.repeatEveryDescription,
          repeats_each_hour: this.repeatsEachHour,
          all_day_week: this.allDayWeek,

          single_activity: this.data.single_activity,
          activities_config_id: this.activityId,

          has_plan: this.data.has_plan,
          from_date: this.fromDate,
          from_time: this.fromTime,
          on: this.selectedPeriodOfMonth,
          hours: this.selectedHoursOfDay,
          days: this.repeatDaysSelect,
          months: this.selectedMonthOfYear,
        },
      };
      apiConnector()
        .post(this.base_url + '/activities_configs.json', params)
        .then(({ data }) => {
          this.grid = data;
          Loader.hide();
          this.closeModal();
        })
        .catch((err) => {
          Loader.hide();
          console.log('Could not set initial value', err);
        });
    },
    getAreaOptions: function () {
      return apiConnector()
        .get(this.base_url + '/activities_configs.json?type=area')
        .then(({ data }) => {
          return data.map((e) => [e.description, e.id]);
        })
        .catch((err) => {
          console.log('Could not set initial value', err);
        });
    },
    getActivityById: function (id) {
      return apiConnector()
        .get(this.base_url + '/activities_configs/' + id + '.json')
        .then(({ data }) => {
          return data;
        })
        .catch((err) => {
          console.log('Could not set initial value', err);
        });
    },
    async getSubActivities(activityId) {
      try {
        const response = await apiConnector().get(
          `${this.base_url}/activities_configs/get_sub_activities_configs.json?activity_config_id=${activityId}`,
        );
        return response.data.results;
      } catch (error) {
        console.log('Could not fetch sub_activities', error);
      }
    },
    updateGap: function () {
      if (this.requiredForSave) {
        return false;
      }
      Loader.show();

      let params = {
        guest_activity_plan: this.buildGap,
      };

      apiConnector()
        .patch(this.base_url + '/guest_activity_plans/' + this.connected_plans + '.json', params)
        .then((res) => {
          Loader.hide();
          this.closeModal();
          if (this.domiciliare) {
            window.location.reload();
          } else {
            if (Object.keys(this.callback_function_on_success).length > 0) {
              const { name, parameters } = this.callback_function_on_success;
              eval(`${name}(${parameters})`);
            }
          }
        })
        .catch((err) => {
          if (err.response && err.response.data) {
            if (err.response.data.base && err.response.data.base[0]) {
              this.error_msg = err.response.data.base[0];
            }
            if (err.response.data.errore) {
              this.error_msg = err.response.data.errore;
            }
          }
          Loader.hide();
          console.log('Could not set initial value', err);
        });
    },
    createGap: function () {
      if (this.requiredForSave) {
        return false;
      }
      Loader.show();

      //  Per retro compatibilità pre polimorfica
      if (this.fix_model_type === 'GuestDrug') {
        this.guest_drug_id = this.fix_model_id;
      }

      let params = {
        guest_activity_plan: this.buildGap,
      };
      apiConnector()
        .post(this.base_url + '/guest_activity_plans.json', params)
        .then((res) => {
          Loader.hide();
          this.closeModal();
          if (this.domiciliare) {
            window.location.reload();
          } else {
            if (Object.keys(this.callback_function_on_success).length > 0) {
              const { name, parameters } = this.callback_function_on_success;
              eval(`${name}(${parameters})`);
            }
          }
        })
        .catch((err) => {
          if (err.response && err.response.data) {
            if (err.response.data.base && err.response.data.base[0]) {
              this.error_msg = err.response.data.base[0];
            }
            if (err.response.data.errore) {
              this.error_msg = err.response.data.errore;
            }
          }
          Loader.hide();
          console.log('Could not set initial value', err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
input {
  margin-bottom: 0;
}

.input-checkbox-auto {
  display: inline-block;

  padding: 0 12.5px 0 0;

  input {
    margin: 0 0 3px 0;
  }
}

.section {
  margin: 15px 0;
}

.actionsContainer {
  margin-top: 15px;
  margin-bottom: 15px;
}

.infoContainer {
  margin-top: 20px;
  width: 100%;

  .info-title {
    width: 100%;
  }

  .m_top {
    margin-top: 10px;
  }

  .wrapper {
    display: flex;

    .extended {
      width: 100%;
    }

    .choser,
    .viewer {
      width: 50%;
    }

    .choser {
      flex: 1;
    }

    .viewer {
      flex: 1;
      padding: 5px 25px;

      dl {
        margin: 0;
      }
    }
  }
}

.sub-activities-configs-list {
  max-height: 200px;
  overflow-y: auto;
}
</style>
